import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SciencePage from "../pages/science/page";
import AboutPage from "../pages/about/page";
import SymptomsPage from "../pages/symptoms/page";
import CommunityPage from "../pages/community/page";
import ResourcesPage from "../pages/resources/page";
import ResearchPage from "../pages/research/page";
import InvolvedPage from "../pages/involved/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/science",
    element: <SciencePage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/symptoms",
    element: <SymptomsPage />,
  },
  {
    path: "/community",
    element: <CommunityPage />,
  },
  {
    path: "/resources",
    element: <ResourcesPage />,
  },
  {
    path: "/research",
    element: <ResearchPage />,
  },
  {
    path: "/get-involved",
    element: <InvolvedPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
